var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('w-translate-text',{attrs:{"text":_vm.text,"fromLanguage":'en',"toLanguage":_vm.locale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }